import { render, staticRenderFns } from "./BCardCode.vue?vue&type=template&id=6b5c6a5e&scoped=true"
import script from "./BCardCode.vue?vue&type=script&lang=js"
export * from "./BCardCode.vue?vue&type=script&lang=js"
import style0 from "./BCardCode.vue?vue&type=style&index=0&id=6b5c6a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c6a5e",
  null
  
)

export default component.exports